<template>
    <div
        v-if="show"
        class="fixed inset-0 z-50 flex items-center justify-center"
    >
        <div
            class="absolute inset-0 bg-slate-900/50"
            @click="$emit('update:show', false)"
        ></div>
        <div
            class="relative bg-white dark:bg-slate-800 rounded-lg shadow-lg w-full max-w-sm md:max-w-md mx-4 p-6"
        >
            <div class="flex items-center justify-between mb-6">
                <h3 class="text-xl font-medium text-slate-900 dark:text-slate-100">
                    Edit billing email
                </h3>
                <button
                    class="p-2 rounded hover:bg-slate-100 dark:hover:bg-slate-700 dark:bg-slate-700 transition-colors"
                    @click="$emit('update:show', false)"
                >
                    <Icon icon="close" class="w-5 h-5 text-slate-500 dark:text-slate-400" />
                </button>
            </div>

            <div>
                <label
                    class="block text-sm font-medium text-slate-700 dark:text-slate-200 mb-1.5"
                >
                    Billing email
                </label>
                <input
                    v-model="emailForm"
                    type="email"
                    placeholder="Enter email address"
                    class="w-full px-3 py-2.5 border border-slate-200 dark:border-slate-700 rounded text-sm focus:outline-none focus:ring-1 focus:ring-orange focus:border-orange"
                />
                <p
                    class="flex items-center gap-1.5 text-xs text-slate-400 mt-2"
                >
                    <svg
                        class="w-3.5 h-3.5 shrink-0"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clip-rule="evenodd"
                        />
                    </svg>
                    This email address will appear on invoices.
                </p>
            </div>

            <div v-if="emailError" class="text-sm text-red-500 mt-4">
                {{ emailError }}
            </div>

            <div class="flex justify-end gap-3 mt-6">
                <button
                    class="px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-medium text-slate-900 dark:text-slate-100 rounded shadow-sm hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-900/40 transition-colors"
                    @click="$emit('update:show', false)"
                >
                    Cancel
                </button>
                <button
                    class="px-4 py-2.5 bg-slate-900 text-sm font-medium text-white rounded shadow-sm hover:bg-slate-800 transition-colors disabled:opacity-50"
                    :disabled="emailProcessing"
                    @click="handleSaveBillingEmail"
                >
                    {{ emailProcessing ? 'Saving...' : 'Save changes' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    billingEmail: {
        type: String,
        default: '',
    },
});

const emit = defineEmits(['update:show', 'email-saved']);

const emailForm = ref('');
const emailProcessing = ref(false);
const emailError = ref('');

watch(
    () => props.show,
    (val) => {
        if (val) {
            emailForm.value = props.billingEmail || '';
            emailError.value = '';
        }
    }
);

const handleSaveBillingEmail = async () => {
    if (!emailForm.value || !emailForm.value.includes('@')) {
        emailError.value = 'Please enter a valid email address.';
        return;
    }

    emailProcessing.value = true;
    emailError.value = '';

    try {
        await ApiService.apiCall('/travel-plus/billing-email', 'put', {
            email: emailForm.value,
        });

        emit('email-saved', emailForm.value);
        emit('update:show', false);
    } catch (e) {
        emailError.value =
            e?.response?.data?.message ||
            'Something went wrong. Please try again.';
    } finally {
        emailProcessing.value = false;
    }
};
</script>
